import React, { useState, useEffect } from 'react';
//Imports svg
import messageGreen from '../../assets/icons/messageGreen.svg';
import messageRed from '../../assets/icons/messageRed.svg';
import errorIcon from '../../assets/icons/error.svg';
import ok from '../../assets/icons/ok.svg';
//Import Style
import './message.css';

function MessageConfirmation({ confirmation, error, view }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (confirmation || error) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [confirmation, error]);
  
  // Determinar qué recursos mostrar según el tipo de mensaje
  const messageImgSrc = confirmation ? messageGreen : messageRed;
  const iconImgSrc = confirmation ? ok : errorIcon;
  const messageText = confirmation 
    ? 'Cambios guardados exitosamente.' 
    : 'No se pudo guardar los cambios.';

  // Si no hay mensaje para mostrar, no renderizar nada
  if (!confirmation && !error) {
    return null;
  }

  return (
    <>
      <img
        src={messageImgSrc}
        className={`svg-content flex ${show ? 'show' : ''} ${view ? 'bottom-view' : ''}`}
        alt="Contenedor de mensaje"
      />
      <aside className={`content-message flex ${show ? 'show' : ''} ${view ? 'bottom-view' : ''}`}>
        <img
          src={iconImgSrc}
          className="icon"
          alt={confirmation ? "Éxito" : "Error"}
        />
        <p className="content-p">{messageText}</p>
      </aside>
    </>
  );
}

export default MessageConfirmation;